import React, { Component } from 'react';
import PropTypes from 'prop-types';
import buttonClick from '../assets/audio/glossy_click_26.wav';

class Button extends Component {

    constructor( props ) {
        super( props );

        this.buttonClickSound = new Audio( buttonClick );
        this._onClick = this._onClick.bind( this );
    }

    _onClick() {
        const { onClick } = this.props;
        this.buttonClickSound.currentTime = 0;
        this.buttonClickSound.play();

        onClick();
    }

    render() {
        const { className, children } = this.props;

        return(
            <button className={ "btn " + className } onClick={ this._onClick }>
                { children }
            </button>
        );
    }

}

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/button.js